import React from 'react';
import { ResponsiveBar } from '@nivo/bar';

import { useFieldsObject } from '../hooks/useFields';

const barChartOptions = {
  indexBy: 'nom_ppal',
  groupMode: 'stacked',
  borderRadius: 1,
  margin: {
    top: 20,
    bottom: 30,
    left: 70,
  },
  legends: [
    {
      dataFrom: 'keys',
      anchor: 'top-left',
      direction: 'column',
      translateY: 0,
      itemsSpacing: 2,
      itemWidth: 100,
      itemHeight: 20,
      itemDirection: 'left-to-right',
    },
  ],
  axisLeft: {
    legend: 'Effectifs',
    legendPosition: 'middle',
    legendOffset: -50,
  },
  axisBottom: {
    tickPadding: 15,
  },
};

const renderTick = zones => tick => (
  <g key={tick.key} transform={`translate(${tick.x},${tick.y + 22})`}>
    <text
      textAnchor="middle"
      alignmentBaseline="middle"
      style={{
        ...tick.theme.axis.ticks.text,
        fill: zones[tick.tickIndex].color,
      }}
    >
      {tick.value}
    </text>
  </g>
);

const buildBarChart = (zones = [], fields = [], labels = {}) => {
  const seenFields = new Set();

  const {
    indexBy,
    legends: [legend],
    margin,
    axisBottom,
  } = barChartOptions;

  const data = zones.map(zone => ({
    [indexBy]: zone[indexBy],
    ...fields.reduce((acc, field) => {
      const value = zone[field] && +zone[field].toString().replace(/\s/g, '');

      if (!value) {
        return acc;
      }

      seenFields.add(field);

      return {
        ...acc,
        [labels[field]]: value,
      };
    }, {}),
  }));

  const keys = Array.from(seenFields).map(field => labels[field]);
  const legendHeight = (legend.itemHeight + legend.itemsSpacing) * seenFields.size;

  return {
    ...barChartOptions,
    data,
    keys,
    margin: { ...margin, top: margin.top + legendHeight },
    legends: [{ ...legend, translateY: -1 * legendHeight - 10 }],
    axisBottom: { ...axisBottom, renderTick: renderTick(zones) },
  };
};

const ZoneBars = ({ zones }) => {
  const labels = {
    ...useFieldsObject(),
    pres_eff: 'Sphère présentielle',
    nb_productif_eff: 'Sphère productive',

  };

  return (
    <div style={{ height: 400 }}>
      <ResponsiveBar {...buildBarChart(
        zones,
        ['pres_eff', 'nb_productif_eff'],
        labels,
      )}
      />
    </div>
  );
};

export default ZoneBars;
